import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const BASE_URL = "https://api.shubhamraj01.in";

const STATUS_STYLES = {
  PENDING:          { bg: "#fef3c7", color: "#92400e" },
  OUT_FOR_DELIVERY: { bg: "#dbeafe", color: "#1e40af" },
  DELIVERED:        { bg: "#d1fae5", color: "#065f46" },
  COMPLETED:        { bg: "#d1fae5", color: "#065f46" },
  CONFIRMED:        { bg: "#ede9fe", color: "#5b21b6" },
  CANCELLED:        { bg: "#fee2e2", color: "#991b1b" },
};

export default function OrdersPage({ openAuthModal, setActivePage }) {
  const { token, isLoggedIn } = useAuth();
  const [orders, setOrders]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState("");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (!isLoggedIn()) { openAuthModal("login"); return; }
    loadOrders();
  }, []);

  const loadOrders = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/api/order/user`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (!res.ok) throw new Error("Orders load nahi hue");
      const data = await res.json();
      setOrders([...data].reverse());
    } catch(e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "numeric", month: "short", year: "numeric",
    });
  };

  return (
    <div>
      {/* Header */}
      <div style={{
        padding: "2rem clamp(1rem,5vw,3rem)",
        borderBottom: "1px solid var(--border)",
        background: "var(--surface)",
      }}>
        <h2 style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, fontSize: "1.7rem", letterSpacing: "-0.03em" }}>My Orders</h2>
        <p style={{ color: "var(--text2)", fontSize: ".9rem", marginTop: ".25rem" }}>Your order history</p>
      </div>

      <div style={{ padding: "2rem clamp(1rem,5vw,3rem)", maxWidth: "800px" }}>

        {loading ? (
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            {Array(3).fill(0).map((_, i) => (
              <div key={i} style={{ background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: "16px", padding: "1.5rem" }}>
                <div style={{ height: "20px", width: "40%", marginBottom: "1rem", borderRadius: "8px", background: "linear-gradient(90deg,var(--surface2) 25%,var(--border) 50%,var(--surface2) 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.4s infinite" }} />
                <div style={{ height: "14px", width: "70%", borderRadius: "8px", background: "linear-gradient(90deg,var(--surface2) 25%,var(--border) 50%,var(--surface2) 75%)", backgroundSize: "200% 100%", animation: "shimmer 1.4s infinite" }} />
              </div>
            ))}
          </div>
        ) : error ? (
          <div style={{ textAlign: "center", padding: "4rem", color: "var(--text3)" }}>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>{"⚠️"}</div>
            <p>{error}</p>
          </div>
        ) : orders.length === 0 ? (
          <div style={{ textAlign: "center", padding: "4rem", color: "var(--text3)" }}>
            <div style={{ fontSize: "4rem", marginBottom: "1rem" }}>{"📭"}</div>
            <h3 style={{ fontFamily: "'Syne',sans-serif", fontWeight: 800, marginBottom: ".5rem" }}>No orders yet</h3>
            <p style={{ fontSize: ".9rem", marginBottom: "1.5rem" }}>Apna pehla order place karo!</p>
            <button
              onClick={() => setActivePage("restaurants")}
              style={{
                background: "var(--primary)", color: "#fff", border: "none",
                padding: ".6rem 1.5rem", borderRadius: "99px",
                fontWeight: 600, fontSize: ".9rem", cursor: "pointer",
                fontFamily: "inherit",
              }}
            >
              Explore Restaurants
            </button>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
            {orders.map(order => {
              const statusStyle = STATUS_STYLES[order.orderStatus] || { bg: "#f3f4f6", color: "#374151" };
              return (
                <div key={order.id} style={{
                  background: "var(--surface)", border: "1.5px solid var(--border)",
                  borderRadius: "16px", padding: "1.25rem 1.5rem",
                  transition: "border-color .2s",
                }}
                  onMouseEnter={e => e.currentTarget.style.borderColor = "var(--primary)"}
                  onMouseLeave={e => e.currentTarget.style.borderColor = "var(--border)"}
                >
                  {/* Header */}
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "1rem" }}>
                    <div>
                      <span style={{ fontFamily: "'Syne',sans-serif", fontWeight: 700, fontSize: ".95rem" }}>
                        Order #{order.id}
                      </span>
                      {order.restaurant?.name && (
                        <span style={{ fontSize: ".8rem", color: "var(--text3)", marginLeft: ".5rem" }}>
                          · {order.restaurant.name}
                        </span>
                      )}
                    </div>
                    <span style={{
                      fontSize: ".72rem", fontWeight: 700,
                      padding: ".3rem .75rem", borderRadius: "99px",
                      textTransform: "uppercase", letterSpacing: ".06em",
                      background: statusStyle.bg, color: statusStyle.color,
                    }}>
                      {order.orderStatus}
                    </span>
                  </div>

                  {/* Items */}
                  <p style={{ fontSize: ".85rem", color: "var(--text2)", marginBottom: "1rem" }}>
                    {order.items?.map(i => `${i.food?.name || "Item"} x ${i.quantity}`).join(" · ") || "Items unavailable"}
                  </p>

                  {/* Footer */}
                  <div style={{
                    display: "flex", alignItems: "center", justifyContent: "space-between",
                    paddingTop: "1rem", borderTop: "1px solid var(--border)",
                  }}>
                    <span style={{ fontWeight: 700, color: "var(--primary)", fontSize: ".95rem" }}>
                      Rs.{order.totalPrice}
                    </span>
                    <span style={{ fontSize: ".78rem", color: "var(--text3)" }}>
                      {formatDate(order.createdAt)}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}